"use client";

import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { XCircleIcon } from "@heroicons/react/20/solid";

export default function CookieBtn() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        type="button"
        aria-haspopup="dialog"
        onClick={() => setShowModal(true)}
      >
        Cookie Policy
      </button>

      {showModal && (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="Visit Cookie Policy"
          className="fixed inset-0 flex h-full w-full flex-col items-center justify-center overflow-y-auto bg-gray-600 bg-opacity-50"
          onClick={() => setShowModal(false)}
        >
          <div className="mb-2 flex w-full max-w-md justify-end">
            <button
              onClick={() => setShowModal(false)}
              className=" text-gray-50"
              aria-label="Close"
            >
              <XCircleIcon className="h-8 w-8" />
            </button>
          </div>
          <div
            className="mx-4 w-full max-w-md rounded-lg bg-white p-5 shadow-md"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex flex-col items-center">
              <h3 className="text-lg font-medium leading-6 text-gray-900">
                Cookie Policy
              </h3>
              <div className="mt-2 px-7 py-3" role="document">
                <p className="text-sm text-gray-500">
                  Click below to visit our cookie policy page.
                </p>
              </div>
              <div className="items-center px-4 py-3">
                <Link
                  to="/cookie-policy"
                  className="w-auto rounded-md bg-blue-500 px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-blue-700"
                  onClick={() => setShowModal(false)}
                  aria-label="Visit our cookie policy page"
                >
                  Visit Cookie Policy
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
